import { Clip } from '@goldcast/player-config/src/types/clip-types';
import { currentClip } from '@/stores/clip';

// This function is used to update the updated_at field of the current clip with backend updated_at value
export const updateCurrentClipUpdatedAt = (updatedClip: Clip) => {
  if (!updatedClip || !updatedClip.id) {
    return;
  }

  currentClip.update(data => {
    const clipData = data[updatedClip.id];
    if (!clipData) {
      return data;
    }

    const savedClipUpdatedAt = new Date(updatedClip.updated_at).valueOf();
    const clipUpdatedAt = new Date(clipData.updated_at).valueOf();

    if (savedClipUpdatedAt > clipUpdatedAt) {
      clipData.updated_at = updatedClip.updated_at;
    }
    data[updatedClip.id] = { ...clipData };
    return data;
  });
};
